// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2dpnD","selects":"Documents_selects__2dBHK"};